import { Controller } from 'stimulus';

export default class extends Controller {
  requestManualUpload() {
    this.dispatch('manual-upload-requested', {
      prefix: 'moodboard--items',
    });

    setTimeout(() => {
      this.dispatch('tab-name-propagated', {
        prefix: 'moodboard--items',
        detail: { value: 'library' },
      });

      this.dispatch('upload-source-propagated', {
        prefix: 'moodboard--items',
        detail: { value: 'manual' },
      });
    });
  }
}
